import React from 'react';
import { Button, Space, Tooltip, Modal } from 'antd';
import { HomeOutlined, ReloadOutlined } from '@ant-design/icons';
import { Header } from './styled';
import { useDpiDefaultLanding } from '../../../hooks/useDpiDefaultLanding';
import { useResetToDefault } from '@hooks/useCustomerLevelPersistence';
import { OVERVIEW_PERSISTENCE_KEY } from '../../../constants';

const Actions = ({ disabled = false }) => {
  const { handleSetDefaultLanding, isSettingDefault, isDefaultLandingPage } =
    useDpiDefaultLanding();
  const { resetToDefault, isResetting } = useResetToDefault();

  const handleResetToDefault = () => {
    Modal.confirm({
      title: 'Reset to Default',
      content:
        'This will reset your configuration to the default. Any personalizations will be lost.',
      okText: 'Reset',
      cancelText: 'Cancel',
      okType: 'danger',
      onOk: () => resetToDefault(OVERVIEW_PERSISTENCE_KEY),
    });
  };

  return (
    <Space direction="vertical">
      <Header>Actions</Header>
      <>
        <Tooltip title="Set as landing page">
          <Button
            type="text"
            size="small"
            icon={<HomeOutlined />}
            onClick={handleSetDefaultLanding}
            disabled={disabled || isDefaultLandingPage}
            loading={isSettingDefault}
          >
            Set as landing page
          </Button>
        </Tooltip>

        <Tooltip title="Reset your configuration to default">
          <Button
            type="text"
            size="small"
            icon={<ReloadOutlined />}
            onClick={handleResetToDefault}
            loading={isResetting}
            disabled={disabled}
          >
            Reset to default
          </Button>
        </Tooltip>
      </>
    </Space>
  );
};

export default Actions;
